import { useEffect } from 'react'
import { HOME_PRODUCT_KEYS, SECONDARY_VIEW_KEYS } from '@/config/navigation/secondaryNav'
import { usePulseNavStore } from './pulseNavStore'

/**
 * Carries out navigation requests from Pulse panels. Mirrors the rail's own
 * handlers: clearing the selected thread is what lets a /home/* route render
 * instead of the open chat. Ask-bar text goes through the shell's own prefill
 * handler (`onMainAskBarPrefill`), so it focuses and pulses like any prefill.
 */
export function usePulseNavBridge({ navigate, setHomeProduct, setHomeView, setSelectedThreadId, prefillAskBar }) {
  useEffect(
    () =>
      usePulseNavStore.subscribe(({ request }) => {
        if (!request) return
        usePulseNavStore.getState().clear()
        setHomeProduct(HOME_PRODUCT_KEYS.CHAT)
        setHomeView(SECONDARY_VIEW_KEYS.HOME_MAIN)
        setSelectedThreadId(null)
        if (window.location.pathname !== request.path) navigate(request.path)
        if (request.text != null) prefillAskBar?.({ text: request.text })
      }),
    [navigate, setHomeProduct, setHomeView, setSelectedThreadId, prefillAskBar],
  )
}
